import { orpc } from '@/lib/orpc/client'
import { queryClient } from '@/lib/query'
import { useQuery } from '@tanstack/react-query'

export function useBusinessInfoQuery() {
  // const { businesses } = withNavbarRoute.useLoaderData()

  const businessInfoQuery = useQuery(
    orpc.business.getListOfBusinesses.queryOptions({
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
    }),
  )

  return { businesses: businessInfoQuery.data, ...businessInfoQuery }
}

export function invalidateBusinessInfoQuery() {
  queryClient.invalidateQueries({
    queryKey: orpc.business.getListOfBusinesses.queryKey(),
  })
}

export function ensureBusinessInfoQueryData() {
  return queryClient.ensureQueryData(
    orpc.business.getListOfBusinesses.queryOptions(),
  )
}
